import { render, staticRenderFns } from "./MinisiteDeclareResult.vue?vue&type=template&id=44c72c53&"
import script from "./MinisiteDeclareResult.vue?vue&type=script&lang=js&"
export * from "./MinisiteDeclareResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports